export default "__VITE_ASSET__BDEr8Odd__"